/**
 * Silberfluss API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.10
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AnalyticsFolder { 
    created_at?: string;
    created_by?: string;
    id?: string;
    /**
     * Always true for this type (discriminator for mixed UIs).
     */
    is_folder?: boolean;
    name?: string;
    parent_folder_id?: string | null;
    updated_at?: string;
}

